import { z } from "zod";

export const personAccessDtoSchema = z.object({
  id: z.number(),
  content: z.string(),
  function: z.string(),
  service: z.string(),
});

export type TPersonAccessDto = z.infer<typeof personAccessDtoSchema>;
